import { Tab, TabPanel, Tabs, TabsList } from "@mui/base";
import { useState } from "react";

import { Icon } from "../../assets/icons/Icon";
import { TeamMembersTable } from "../../components/teamMembers/TeamMembersTable";
import { useTeamMembers } from "../../hooks/useTeamMembers";
import NoData from "../containers/NoData";
import Button from "../mantine/button/Button";
import { InviteTeamMemberModal } from "./InviteTeamMemberModal";
import styles from "./TeamMembersTabs.module.scss";

export const TeamsMembersTabs = () => {
  const activeMembers = useTeamMembers("active");
  const pendingMembers = useTeamMembers("pending");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const tabs = [
    {
      label: "Active",
      count: activeMembers.data?.length || "",
      content: (
        <TeamMembersTable
          data={activeMembers.data}
          isLoading={activeMembers.isLoading}
          pagination={activeMembers.pagination}
          setPagination={activeMembers.setPagination}
          type="active"
          authorizations={activeMembers.authorizations}
        />
      ),
    },
    {
      label: "Pending",
      count: pendingMembers.data?.length || "",
      content: !pendingMembers.data?.length ? (
        <NoData title="No Pending Team Members" />
      ) : (
        <TeamMembersTable
          data={pendingMembers.data}
          isLoading={pendingMembers.isLoading}
          pagination={pendingMembers.pagination}
          setPagination={pendingMembers.setPagination}
          type="pending"
          authorizations={pendingMembers.authorizations}
        />
      ),
    },
  ];

  return (
    <>
      <Tabs defaultValue={tabs[0]?.label}>
        <TabsList className={styles.tabsList}>
          {tabs.map((tab) => (
            <Tab key={tab.label} className={styles.tabButton} value={tab.label}>
              {tab.label}
            </Tab>
          ))}
        </TabsList>
        <div className={styles.tabsContent}>
          <div className={styles.tabsContentHeader}>
            <Button onClick={() => setIsModalOpen(true)}>
              <Icon iconName="UserIcon" width="1rem" height="1rem" />
              Invite Member
            </Button>
          </div>
          {tabs.map((tab) => (
            <TabPanel key={tab.label} value={tab.label}>
              {tab.content}
            </TabPanel>
          ))}
        </div>
      </Tabs>

      <InviteTeamMemberModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
